import { useEffect } from "react";

type ActionHandler = (event: Event) => void;

export function useGlobalAction(handler: ActionHandler) {
  useEffect(() => {
    // List of events you want to track globally
    const events: (keyof DocumentEventMap)[] = [
      "click",
      "input",
      "change",
      "keydown",
      "keyup",
      "submit",
    ];

    // Attach event listeners
    events.forEach((eventName) => {
      document.addEventListener(eventName, handler, true); 
      // useCapture = true ensures we catch events before they bubble
    });

    // Cleanup
    return () => {
      events.forEach((eventName) => {
        document.removeEventListener(eventName, handler, true);
      });
    };
  }, [handler]);
}
